module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/ogp-0f83b4d38e73bac12fde83b092743492.png";